export default __webpack_public_path__ + "static/7-a869c379df1193218ac87d036ad5ae11.webp";